// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"f42f478f","703":"036eb0d8","787":"714c4f8c"}[chunkId] + ".chunk.js";
};